'use strict';

/**
 * Pict-Provider-ConnectionsAPI
 * ----------------------------
 * Browser-side client for the generic "connections" of an entity: the auto-gathered links (customer,
 * reporter, work items, media, docs, comments, ...) folded into groups of { Type, Label, Count, Items },
 * the same shape the Blueprint endpoint computes for a work item, generalized to any entity. The
 * Connections grid view renders it. Edit mode links and unlinks one relation at a time.
 *
 *   GET    /1.0/<Entity>/:id/Connections                  -> { Title, Eyebrow, Record, Groups, Available }
 *   GET    /1.0/<Entity>/:id/Connections/Candidates/:type -> [ { ID, Title } ]   (link picker options)
 *   POST   /1.0/<Entity>/:id/Connections/Link             { Type, IDItem }
 *   DELETE /1.0/<Entity>/:id/Connections/Link/:type/:item
 */

const libPictProvider = require('pict').ServiceProviderBase;
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'ConnectionsAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/'
};

class PictProviderConnectionsAPI extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, Object.assign({}, _DefaultProviderConfiguration, pOptions || {}), pServiceHash);
		this.routePrefix = this.options.RoutePrefix;
	}

	_url(pPath) { let tmpPrefix = this.routePrefix; if (tmpPrefix.charAt(tmpPrefix.length - 1) !== '/') { tmpPrefix += '/'; } return tmpPrefix + pPath.replace(/^\//, ''); }
	_base(pEntity, pID) { return encodeURIComponent(pEntity) + '/' + encodeURIComponent(pID) + '/Connections'; }

	get(pEntity, pID)
	{
		return libFrameworkClient.getJSON(this.fable, this._url(this._base(pEntity, pID)))
			.catch(() => null);
	}

	candidates(pEntity, pID, pType)
	{
		return libFrameworkClient.getJSON(this.fable, this._url(this._base(pEntity, pID) + '/Candidates/' + encodeURIComponent(pType)))
			.catch(() => []);
	}

	link(pEntity, pID, pType, pIDItem)
	{
		return libFrameworkClient.postJSON(this.fable, this._url(this._base(pEntity, pID) + '/Link'), { Type: pType, IDItem: pIDItem })
			.catch(() => null);
	}

	unlink(pEntity, pID, pType, pIDItem)
	{
		return libFrameworkClient.delJSON(this.fable, this._url(this._base(pEntity, pID) + '/Link/' + encodeURIComponent(pType) + '/' + encodeURIComponent(pIDItem)))
			.catch(() => null);
	}
}

module.exports = PictProviderConnectionsAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;
